/* eslint-disable react/prop-types */
import React from "react";
import LabelField from "./labelField";
import uploadImage from "./../Images/upload.png";
import uploadPDF from "./../Images/file-upload-blank.png";
import uploadedPDF from "./../Images/file-upload.png";
import uploadExcel from "./../Images/file.png";
import uploadedExcel from "./../Images/file-upload-xls.png";
import uploadVideo from "../Images/upload-video.png";
import uploadedVideo from "../Images/uploaded-video.png";
import Edit from "../Images/edit-grey.png";
import docsUpload from "./../Images/docsUpload.png";
import docsWithoutUpload from "./../Images/docsWithoutUpload.png";
import uploadAudio from "./../Images/audio-upload.png";
import uploadPpt from "./../Images/ppt-upload.png";
import uploadedPpt from "./../Images/ppt-download.png";

function ImagePickerAndViewer({
  labelName,
  value,
  handleChange,
  htmlFor,
  removelabel,
  doctype,
  isRequired,
  disabled,
  isMandatary,
}) {
  const renderPDF = () => {
    if (value)
      return (
        <img
          htmlFor={htmlFor}
          src={uploadedPDF}
          style={{
            width: "50px",
            height: "50px",
          }}
          alt={""}
        />
      );
    else
      return (
        <img
          htmlFor={htmlFor}
          src={uploadPDF}
          style={{
            width: "50px",
            height: "50px",
          }}
          alt={""}
        />
      );
  };

  const renderExcel = () => {
    if (value)
      return (
        <img
          htmlFor={htmlFor}
          src={uploadedExcel}
          style={{
            width: "50px",
            height: "50px",
          }}
          alt={""}
        />
      );
    return (
      <img
        htmlFor={htmlFor}
        src={uploadExcel}
        style={{
          width: "50px",
          height: "50px",
        }}
        alt={""}
      />
    );
  };

  const renderVideo = () => {
    if (value && value !== " ")
      return (
        <img
          htmlFor={htmlFor}
          src={uploadedVideo}
          style={{
            width: "50px",
            height: "50px",
          }}
          alt={""}
        />
      );
    return (
      <img
        htmlFor={htmlFor}
        src={uploadVideo}
        style={{
          width: "50px",
          height: "50px",
        }}
        alt={""}
      />
    );
  };

  const renderAudio = () => {
    if (value)
      return (
        <div>
          <audio
            controls
            style={{
              height: "35px",
              width: "100px",
            }}
          >
            <source src={value} />
          </audio>
        </div>
      );
    else
      return (
        <img
          htmlFor={htmlFor}
          src={uploadAudio}
          style={{
            width: "50px",
            height: "50px",
          }}
          alt={""}
        />
      );
  };

  const renderImage = () => {
    if (value && value !== " ")
      return (
        <img
          htmlFor={htmlFor}
          src={value}
          style={{
            height: "50px",
            maxWidth: "100%",
          }}
          alt={""}
        />
      );
    return (
      <img
        htmlFor={htmlFor}
        src={uploadImage}
        style={{
          height: "50px",
          maxWidth: "100%",
        }}
        alt={""}
      />
    );
  };

  const renderDocs = () => {
    if (value && value !== " ") {
      return (
        <img
          src={docsUpload}
          style={{
            width: "50px",
            height: "50px",
          }}
          alt={""}
        />
      );
    } else {
      return (
        <img
          src={docsWithoutUpload}
          style={{
            width: "50px",
            height: "50px",
          }}
          alt={""}
        />
      );
    }
  };

  const renderPpt = () => {
    if (value && value !== " ") {
      return (
        <img
          src={uploadedPpt}
          style={{
            width: "50px",
            height: "50px",
          }}
          alt={""}
        />
      );
    } else {
      return (
        <img
          src={uploadPpt}
          style={{
            width: "50px",
            height: "50px",
          }}
          alt={""}
        />
      );
    }
  };

  const renderMediaInput = () => {
    if (doctype === "pdf") return renderPDF();
    else if (doctype === "video") return renderVideo();
    else if (doctype === "audio") return renderAudio();
    else if (!doctype) return renderImage();
    else if (doctype === "excel") return renderExcel();
    else if (doctype === "pdf/image") return renderPDF();
    else if (doctype === "docx") return renderDocs();
    else if (doctype === "ppt") return renderPpt();
    else if (doctype === "pdf/docx") return renderDocs();

    <img
      src={Edit}
      className="cursor"
      alt="Edit"
      style={{
        width: "13px",
        position: "absolute",
        right: "0",
        bottom: "0px",
      }}
    />;
  };

  return (
    <div className="d-flex mb-2 align-items-center">
      {removelabel ? null : (
        <LabelField labelName={labelName} isRequired={isRequired} />
      )}

      <label htmlFor={htmlFor} className="custom-file-upload fas cursor ">
        {renderMediaInput()}
        <input
          id={htmlFor}
          style={{ display: "none" }}
          type="file"
          disabled={disabled}
          onClick={(e) => (e.target.value = null)}
          onChange={(e) => handleChange(e)}
          accept={
            doctype === "pdf"
              ? ".pdf"
              : doctype === "video"
                ? "video/mp4, .mkv, video/*"
                : doctype === "excel"
                  ? ".xls,.xlsx"
                  : doctype === "audio"
                    ? ".mp3,.wav,.ogg"
                    : doctype === "docx"
                      ? ".docx, doc"
                      : doctype === "pdf/docx" // NEW
                        ? ".pdf,.doc,.docx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                        : doctype === "ppt"
                          ? ".ppt,.pptx,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation"
                          : doctype === "pdf/image"
                            ? "image/png, image/gif, image/jpeg, ,image/webp, .pdf"
                            : "image/png, image/gif, image/jpeg,image/webp"
          }
        />
      </label>
      {isMandatary ? <span className="required ms-1 fs-6">*</span> : null}
    </div>
  );
}

export default ImagePickerAndViewer;
